import type { LevelDef } from '../level.ts';

// Kingsford Smith: a parallel pair with a crosswind strip cutting both at
// right angles, and a harbour pad for the helicopters. Two streams arriving
// from two different edges, meeting where the runways cross. The whole field
// is tilted off the axes — square to the screen it read as a hash mark.
export const sydney: LevelDef = {
  id: 'sydney', city: 'sydney', country: 'australia',
  blurb: 'harbour water, a pair crossed at right angles, helis to the quay',
  baseline: 420, scoreMul: 1.8,
  capBase: 3, capDiv: 4, capMax: 6,
  spawnLead: [6, 12], minSpawnGap: 1.9, tempo: 1,
  mix: [['light', 0.20], ['medium', 0.24], ['heavy', 0.18], ['jet', 0.20], ['heli', 0.18]],
  layout: {
    runways: [
      { x1: -0.20, y1: 0.68, x2: -0.37, y2: -0.38 },
      { x1: 0.21, y1: 0.59, x2: 0.04, y2: -0.47 },
      { x1: -0.68, y1: 0.27, x2: 0.32, y2: 0.06, w: 24 },
    ],
    pads: [{ x: 0.18, y: 0.25, frac: true }],
  },
  palette: { bg: '#f4f6f1', field: '#e0e8dc', deep: '#d3ddcd', water: '#bfd6dd' },
  decor: ['sails', 'harbour'],
  // the harbour across the top, the quay the pad sits on just below it
  water: [{ x: 0, y: 0 }, { x: 1, y: 0 }, { x: 1, y: 0.14 }, { x: 0.58, y: 0.18 }, { x: 0.26, y: 0.12 }, { x: 0, y: 0.16 }],
  arrivalSides: [0.9, 1, 1.2, 1.1],
  // g4 major pentatonic: most wind, brightest
  music: { root: 67, mode: 'major pentatonic', bpm: 64, wind: 1.0, verb: 0.5, bright: 3600 },
};
